import React, { Component } from 'react';
import { Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Container } from 'reactstrap';
import styles from "./menu.module.scss";
import { Link } from '@reach/router';
import logo from "../../assets/imgs/logo-power-players.png";

export default class NavigationMenu extends Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {
      isOpen: false,
    }
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }
  render() {
    return (
      <div className={styles.navigation}>
        <Navbar className={styles.background} dark expand="md">
          <Container>
            <NavbarBrand className={`${styles.navItem} ${styles.noBorder}`}>
              {
                this.props && this.props.notHome ?
                  <Link to="/"><img className={styles.logo} src={logo} alt="logo Power Players"></img></Link> :
                  <img className={styles.logo} src={logo} alt="logo Power Players"></img>
          }</NavbarBrand>
            <NavbarToggler className={styles.noBorder} onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              {this.props && this.props.notHome ? (
                <Nav className="ml-auto" navbar>
                  <NavItem className={styles.navWrapper}>
                    <div className={styles.navItem}>
                      <Link to="/">Domov</Link>
                    </div>
                  </NavItem>
                </Nav>
              ) : (
                <Nav className="ml-auto" navbar>
                  <NavItem className={styles.navWrapper}>
                    <NavLink className={styles.navItem} href="#about-project">
                      O projekte
                    </NavLink>
                  </NavItem>
                  <NavItem className={styles.navWrapper}>
                    <NavLink className={styles.navItem} href="#team">
                      Náš tím
                    </NavLink>
                  </NavItem>
                  <NavItem className={styles.navWrapper}>
                    <NavLink className={styles.navItem} href="#sprints">
                      Šprinty
                    </NavLink>
                  </NavItem>
                  <NavItem className={styles.navWrapper}>
                    <NavLink className={styles.navItem} href="#documents">
                      Dokumenty
                    </NavLink>
                  </NavItem>
                  <NavItem className={styles.navWrapper}>
                    <NavLink className={styles.navItem} href="#contact">
                      Kontakt
                    </NavLink>
                  </NavItem>
                </Nav>
              )}
            </Collapse>
          </Container>
        </Navbar>
      </div>
    )
  }
}
